/**
 * RBAC v2 role names. Seeded by backend migration 0112 with identical
 * spelling at both levels — `guest(1) · member(2) · admin(3) · owner(4)`.
 * Shared vocabulary for both RBAC v2 axes: the per-hub `hub_role`
 * (`user_project_table.role_id`) and the account-level `user_role`
 * (`user_table.role_id`).
 *
 * DISTINCT from the legacy `ClientAuthRole`/`UserTableAuthRole` in
 * `src/types/auth-role.ts`. The axes coexist; this is the new RBAC v2
 * vocabulary and must not be merged into the legacy enums.
 */
export enum Role {
  Guest = 'guest',
  Member = 'member',
  Admin = 'admin',
  Owner = 'owner',
}

/**
 * Effective hub role for render-time gating: the previewed role when an owner
 * is previewing (`previewed != null`), otherwise the user's real hub role.
 * Render-only — never changes what the backend authorizes.
 */
export const effectiveHubRole = (previewed: Role | null, real: Role): Role =>
  previewed ?? real

/**
 * Whether `role` is in the `allowed` set — the hub-role-axis parallel to the
 * legacy `isRoleAllowed`. Pure; pass the effective hub role from `useHubRole`.
 */
export const isHubRoleAllowed = (
  role: Role,
  allowed: readonly Role[],
): boolean => allowed.includes(role)
